export enum CanConsumptionMessages {
  // region Page, menu and tabs
  menu = "reports.canConsumption.menu",
  title = "reports.canConsumption.title",
  tabDashboard = "reports.canConsumption.tabDashboard",
  tabSyntheticReport = "reports.canConsumption.tabSyntheticReport",
  tabAnalyticReport = "reports.canConsumption.tabAnalyticReport",
  tabGraph = "reports.canConsumption.tabGraph",
  // endregion Page, menu and tabs

  // region Synthetic report column
  volumeCarriedColumn = "reports.canConsumption.volumeCarriedColumn",
  // endregion Synthetic report column

  // region Filters
  filterPeriod = "reports.canConsumption.filterPeriod",
  filterPreset7Days = "reports.canConsumption.filterPreset7Days",
  filterPreset3Days = "reports.canConsumption.filterPreset3Days",
  filterPreset1Day = "reports.canConsumption.filterPreset1Day",
  filterPresetCustom = "reports.canConsumption.filterPresetCustom",
  filterDateFrom = "reports.canConsumption.filterDateFrom",
  filterDateTo = "reports.canConsumption.filterDateTo",
  filterPlants = "reports.canConsumption.filterPlants",
  filterVehicleTypes = "reports.canConsumption.filterVehicleTypes",
  filterAllVehicleTypes = "reports.canConsumption.filterAllVehicleTypes",
  filterAlertLimits = "reports.canConsumption.filterAlertLimits",
  /** Plural noun used to summarise how many plants the filter kept */
  filterPlantsPlural = "reports.canConsumption.filterPlantsPlural",
  /** Plural noun used to summarise how many equipment types the filter kept */
  filterVehicleTypesPlural = "reports.canConsumption.filterVehicleTypesPlural",
  // endregion Filters

  // region Period line
  periodSummary = "reports.canConsumption.periodSummary",
  periodConsolidatingWarning = "reports.canConsumption.periodConsolidatingWarning",
  periodNoData = "reports.canConsumption.periodNoData",
  // endregion Period line

  // region Metrics
  metricLitersPerM3Label = "reports.canConsumption.metricLitersPerM3Label",
  metricLitersPerM3Short = "reports.canConsumption.metricLitersPerM3Short",
  metricLitersPerM3Unit = "reports.canConsumption.metricLitersPerM3Unit",
  metricKmPerLiterLabel = "reports.canConsumption.metricKmPerLiterLabel",
  metricKmPerLiterShort = "reports.canConsumption.metricKmPerLiterShort",
  metricKmPerLiterUnit = "reports.canConsumption.metricKmPerLiterUnit",
  metricLitersPerTravelLabel = "reports.canConsumption.metricLitersPerTravelLabel",
  metricLitersPerTravelShort = "reports.canConsumption.metricLitersPerTravelShort",
  metricLitersPerTravelUnit = "reports.canConsumption.metricLitersPerTravelUnit",
  metricLitersPerHourLabel = "reports.canConsumption.metricLitersPerHourLabel",
  metricLitersPerHourShort = "reports.canConsumption.metricLitersPerHourShort",
  metricLitersPerHourUnit = "reports.canConsumption.metricLitersPerHourUnit",
  metricIdleLitersPerHourLabel = "reports.canConsumption.metricIdleLitersPerHourLabel",
  metricIdleLitersPerHourShort = "reports.canConsumption.metricIdleLitersPerHourShort",
  metricIdleLitersPerHourUnit = "reports.canConsumption.metricIdleLitersPerHourUnit",
  hintLowerIsBetter = "reports.canConsumption.hintLowerIsBetter",
  hintHigherIsBetter = "reports.canConsumption.hintHigherIsBetter",
  // endregion Metrics

  // region Gauges
  zoneOk = "reports.canConsumption.zoneOk",
  zoneWarn = "reports.canConsumption.zoneWarn",
  zoneCritical = "reports.canConsumption.zoneCritical",
  gaugeThresholds = "reports.canConsumption.gaugeThresholds",
  gaugeNoData = "reports.canConsumption.gaugeNoData",
  // endregion Gauges

  // region Totals
  tileVolume = "reports.canConsumption.tileVolume",
  tileVolumeFoot = "reports.canConsumption.tileVolumeFoot",
  tileFuel = "reports.canConsumption.tileFuel",
  tileFuelFoot = "reports.canConsumption.tileFuelFoot",
  tileFuelInside = "reports.canConsumption.tileFuelInside",
  tileFuelInsideFoot = "reports.canConsumption.tileFuelInsideFoot",
  tileFuelBetween = "reports.canConsumption.tileFuelBetween",
  tileFuelBetweenFoot = "reports.canConsumption.tileFuelBetweenFoot",
  tileFuelBetweenHint = "reports.canConsumption.tileFuelBetweenHint",
  tileHoursBetween = "reports.canConsumption.tileHoursBetween",
  tileHoursBetweenFoot = "reports.canConsumption.tileHoursBetweenFoot",
  tileHoursBetweenHint = "reports.canConsumption.tileHoursBetweenHint",
  tileAvgKmPerTravel = "reports.canConsumption.tileAvgKmPerTravel",
  tileAvgKmPerTravelFoot = "reports.canConsumption.tileAvgKmPerTravelFoot",
  tileAvgSpeed = "reports.canConsumption.tileAvgSpeed",
  tileAvgSpeedFoot = "reports.canConsumption.tileAvgSpeedFoot",
  tileAvgTravelTime = "reports.canConsumption.tileAvgTravelTime",
  tileAvgTravelTimeFoot = "reports.canConsumption.tileAvgTravelTimeFoot",
  tileAttention = "reports.canConsumption.tileAttention",
  tileAttentionFoot = "reports.canConsumption.tileAttentionFoot",
  // endregion Totals

  // region Ranking
  rankingTitle = "reports.canConsumption.rankingTitle",
  rankingSubtitle = "reports.canConsumption.rankingSubtitle",
  rankingMetricLabel = "reports.canConsumption.rankingMetricLabel",
  rankingFallbackNote = "reports.canConsumption.rankingFallbackNote",
  rankingEmpty = "reports.canConsumption.rankingEmpty",
  // endregion Ranking

  // region Daily series
  dailyTitle = "reports.canConsumption.dailyTitle",
  dailySubtitle = "reports.canConsumption.dailySubtitle",
  dailyFoot = "reports.canConsumption.dailyFoot",
  dailyBarsVolume = "reports.canConsumption.dailyBarsVolume",
  dailyBarsFuel = "reports.canConsumption.dailyBarsFuel",
  dailyNoOperation = "reports.canConsumption.dailyNoOperation",
  dailyConsolidating = "reports.canConsumption.dailyConsolidating",
  dailyConsolidatingLegend = "reports.canConsumption.dailyConsolidatingLegend",
  // endregion Daily series

  // region Plant totals
  plantsTitle = "reports.canConsumption.plantsTitle",
  plantsSubtitle = "reports.canConsumption.plantsSubtitle",
  plantsNoPlantRow = "reports.canConsumption.plantsNoPlantRow",
  columnPlant = "reports.canConsumption.columnPlant",
  // endregion Plant totals

  // region Vehicle table
  tableTitle = "reports.canConsumption.tableTitle",
  columnVehicle = "reports.canConsumption.columnVehicle",
  columnVehicleType = "reports.canConsumption.columnVehicleType",
  columnPlants = "reports.canConsumption.columnPlants",
  columnTravels = "reports.canConsumption.columnTravels",
  columnVolume = "reports.canConsumption.columnVolume",
  columnDistance = "reports.canConsumption.columnDistance",
  columnFuel = "reports.canConsumption.columnFuel",
  columnAvgKmPerTravel = "reports.canConsumption.columnAvgKmPerTravel",
  columnAvgSpeed = "reports.canConsumption.columnAvgSpeed",
  columnAvgTravelTime = "reports.canConsumption.columnAvgTravelTime",
  tableLowSample = "reports.canConsumption.tableLowSample",
  tableEmpty = "reports.canConsumption.tableEmpty",
  legendBest = "reports.canConsumption.legendBest",
  legendWorst = "reports.canConsumption.legendWorst",
  legendHigherIsBetter = "reports.canConsumption.legendHigherIsBetter",
  legendNoColor = "reports.canConsumption.legendNoColor",
  // endregion Vehicle table

  // region Alert limits modal
  limitsTitle = "reports.canConsumption.limitsTitle",
  limitsSubtitle = "reports.canConsumption.limitsSubtitle",
  limitsWarn = "reports.canConsumption.limitsWarn",
  limitsCritical = "reports.canConsumption.limitsCritical",
  limitsFleetMedian = "reports.canConsumption.limitsFleetMedian",
  limitsReset = "reports.canConsumption.limitsReset",
  limitsDone = "reports.canConsumption.limitsDone",
  limitsClose = "reports.canConsumption.limitsClose"
  // endregion Alert limits modal
}

export type TranslationCanConsumptionMessages = {
  [CanConsumptionMessages.menu]: string,
  [CanConsumptionMessages.title]: string,
  [CanConsumptionMessages.tabDashboard]: string,
  [CanConsumptionMessages.tabSyntheticReport]: string,
  [CanConsumptionMessages.tabAnalyticReport]: string,
  [CanConsumptionMessages.tabGraph]: string,
  [CanConsumptionMessages.volumeCarriedColumn]: string,
  [CanConsumptionMessages.filterPeriod]: string,
  [CanConsumptionMessages.filterPreset7Days]: string,
  [CanConsumptionMessages.filterPreset3Days]: string,
  [CanConsumptionMessages.filterPreset1Day]: string,
  [CanConsumptionMessages.filterPresetCustom]: string,
  [CanConsumptionMessages.filterDateFrom]: string,
  [CanConsumptionMessages.filterDateTo]: string,
  [CanConsumptionMessages.filterPlants]: string,
  [CanConsumptionMessages.filterVehicleTypes]: string,
  [CanConsumptionMessages.filterAllVehicleTypes]: string,
  [CanConsumptionMessages.filterAlertLimits]: string,
  [CanConsumptionMessages.filterPlantsPlural]: string,
  [CanConsumptionMessages.filterVehicleTypesPlural]: string,
  [CanConsumptionMessages.periodSummary]: string,
  [CanConsumptionMessages.periodConsolidatingWarning]: string,
  [CanConsumptionMessages.periodNoData]: string,
  [CanConsumptionMessages.metricLitersPerM3Label]: string,
  [CanConsumptionMessages.metricLitersPerM3Short]: string,
  [CanConsumptionMessages.metricLitersPerM3Unit]: string,
  [CanConsumptionMessages.metricKmPerLiterLabel]: string,
  [CanConsumptionMessages.metricKmPerLiterShort]: string,
  [CanConsumptionMessages.metricKmPerLiterUnit]: string,
  [CanConsumptionMessages.metricLitersPerTravelLabel]: string,
  [CanConsumptionMessages.metricLitersPerTravelShort]: string,
  [CanConsumptionMessages.metricLitersPerTravelUnit]: string,
  [CanConsumptionMessages.metricLitersPerHourLabel]: string,
  [CanConsumptionMessages.metricLitersPerHourShort]: string,
  [CanConsumptionMessages.metricLitersPerHourUnit]: string,
  [CanConsumptionMessages.metricIdleLitersPerHourLabel]: string,
  [CanConsumptionMessages.metricIdleLitersPerHourShort]: string,
  [CanConsumptionMessages.metricIdleLitersPerHourUnit]: string,
  [CanConsumptionMessages.hintLowerIsBetter]: string,
  [CanConsumptionMessages.hintHigherIsBetter]: string,
  [CanConsumptionMessages.zoneOk]: string,
  [CanConsumptionMessages.zoneWarn]: string,
  [CanConsumptionMessages.zoneCritical]: string,
  [CanConsumptionMessages.gaugeThresholds]: string,
  [CanConsumptionMessages.gaugeNoData]: string,
  [CanConsumptionMessages.tileVolume]: string,
  [CanConsumptionMessages.tileVolumeFoot]: string,
  [CanConsumptionMessages.tileFuel]: string,
  [CanConsumptionMessages.tileFuelFoot]: string,
  [CanConsumptionMessages.tileFuelInside]: string,
  [CanConsumptionMessages.tileFuelInsideFoot]: string,
  [CanConsumptionMessages.tileFuelBetween]: string,
  [CanConsumptionMessages.tileFuelBetweenFoot]: string,
  [CanConsumptionMessages.tileFuelBetweenHint]: string,
  [CanConsumptionMessages.tileHoursBetween]: string,
  [CanConsumptionMessages.tileHoursBetweenFoot]: string,
  [CanConsumptionMessages.tileHoursBetweenHint]: string,
  [CanConsumptionMessages.tileAvgKmPerTravel]: string,
  [CanConsumptionMessages.tileAvgKmPerTravelFoot]: string,
  [CanConsumptionMessages.tileAvgSpeed]: string,
  [CanConsumptionMessages.tileAvgSpeedFoot]: string,
  [CanConsumptionMessages.tileAvgTravelTime]: string,
  [CanConsumptionMessages.tileAvgTravelTimeFoot]: string,
  [CanConsumptionMessages.tileAttention]: string,
  [CanConsumptionMessages.tileAttentionFoot]: string,
  [CanConsumptionMessages.rankingTitle]: string,
  [CanConsumptionMessages.rankingSubtitle]: string,
  [CanConsumptionMessages.rankingMetricLabel]: string,
  [CanConsumptionMessages.rankingFallbackNote]: string,
  [CanConsumptionMessages.rankingEmpty]: string,
  [CanConsumptionMessages.dailyTitle]: string,
  [CanConsumptionMessages.dailySubtitle]: string,
  [CanConsumptionMessages.dailyFoot]: string,
  [CanConsumptionMessages.dailyBarsVolume]: string,
  [CanConsumptionMessages.dailyBarsFuel]: string,
  [CanConsumptionMessages.dailyNoOperation]: string,
  [CanConsumptionMessages.dailyConsolidating]: string,
  [CanConsumptionMessages.dailyConsolidatingLegend]: string,
  [CanConsumptionMessages.plantsTitle]: string,
  [CanConsumptionMessages.plantsSubtitle]: string,
  [CanConsumptionMessages.plantsNoPlantRow]: string,
  [CanConsumptionMessages.columnPlant]: string,
  [CanConsumptionMessages.tableTitle]: string,
  [CanConsumptionMessages.columnVehicle]: string,
  [CanConsumptionMessages.columnVehicleType]: string,
  [CanConsumptionMessages.columnPlants]: string,
  [CanConsumptionMessages.columnTravels]: string,
  [CanConsumptionMessages.columnVolume]: string,
  [CanConsumptionMessages.columnDistance]: string,
  [CanConsumptionMessages.columnFuel]: string,
  [CanConsumptionMessages.columnAvgKmPerTravel]: string,
  [CanConsumptionMessages.columnAvgSpeed]: string,
  [CanConsumptionMessages.columnAvgTravelTime]: string,
  [CanConsumptionMessages.tableLowSample]: string,
  [CanConsumptionMessages.tableEmpty]: string,
  [CanConsumptionMessages.legendBest]: string,
  [CanConsumptionMessages.legendWorst]: string,
  [CanConsumptionMessages.legendHigherIsBetter]: string,
  [CanConsumptionMessages.legendNoColor]: string,
  [CanConsumptionMessages.limitsTitle]: string,
  [CanConsumptionMessages.limitsSubtitle]: string,
  [CanConsumptionMessages.limitsWarn]: string,
  [CanConsumptionMessages.limitsCritical]: string,
  [CanConsumptionMessages.limitsFleetMedian]: string,
  [CanConsumptionMessages.limitsReset]: string,
  [CanConsumptionMessages.limitsDone]: string,
  [CanConsumptionMessages.limitsClose]: string
};
